'use client'

import {ReactNode} from 'react'
import {useSidebar} from '../sidebar-visiblity-context'
import s from '../style.module.scss'
import clsx from 'clsx'
import {SwipeableHandlers, useSwipeable} from 'react-swipeable'
import SidebarBackdrop from '../sidebar-backdrop'

interface Props {
  children: ReactNode
  isMobile: boolean
  closeThreshold?: number
}

const SidebarDraggableWrapperClient: React.FC<Props> = ({children, isMobile}) => {
  const {isOpen, closeSidebar} = useSidebar()
  const handlers: SwipeableHandlers = useSwipeable({
    onSwipedLeft: closeSidebar,
    trackMouse: true,
  })

  return (
    isMobile && (
      <>
        <aside
          className={clsx(s.sidebar_container, {
            [s.sidebar_open]: isOpen,
            [s.sidebar_close]: !isOpen,
          })}
          {...handlers}
        >
          {isOpen && children}
        </aside>
        <SidebarBackdrop />
      </>
    )
  )
}

export default SidebarDraggableWrapperClient
